<template>
  <div id="map-controls-sidebar-private-plot">
    <vs-sidebar
      click-not-close
      hidden-background
      position-right
      v-model="activePrivatePlotSidebar"
      class="items-no-padding"
    >
      <div class="h-full">
        <div
          class="customizer-header mt-6 flex items-center justify-between px-6"
        >
          <div>
            <span class="mb-1 aisea-text-18-700-white"
              >プライベートプロット</span
            >
            <div class="aisea-text-12-400-white">自社のプロット一覧を表示</div>
          </div>
          <feather-icon
            icon="XIcon"
            @click.stop="SET_ACTIVE_PRIVATE_PLOT_SIDEBAR(false)"
            svgClasses="live-map-controls-close"
            class="cursor-pointer"
          ></feather-icon>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY" />

        <div class="px-6 mt-4">
          <vs-row vs-type="flex" vs-justify="center" vs-align="center">
            <vs-col
              vs-w="6"
              vs-type="flex"
              vs-justify="flex-start"
              vs-align="center"
            >
              <span class="aisea-text-14-400-white">プロットを登録する</span>
            </vs-col>
            <vs-col
              vs-w="6"
              vs-type="flex"
              vs-justify="flex-end"
              vs-align="center"
            >
              <plot-select />
            </vs-col>
          </vs-row>
        </div>

        <vs-divider class="mb-0" :color="AISEA_COLOR.GRAY" />

        <component
          :is="scrollbarTag"
          class="scroll-area--customizer pt-4 pb-6"
          :settings="settings"
        >
          <ul>
            <li
              class="pb-2 pl-4 pr-4"
              v-for="plot in enterprisePrivatePlots"
              :key="plot.hash"
            >
              <private-plot-item
                :plot="plot"
                :jumpToPlot="jumpToPlot"
                @showDetails="showVesselDetail($event)"
              />
            </li>
          </ul>
        </component>
      </div>
    </vs-sidebar>
  </div>
</template>

<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import { createNamespacedHelpers } from "vuex";
import { ColorMixin } from "@/mixins";
import AuthService from "@/services/authService";

const {
  mapActions: mapActionsOfLiveMap,
  mapState: mapStateOfLiveMap,
  mapMutations: mapMutationsOfLiveMap,
} = createNamespacedHelpers("liveMap");

const { mapGetters: mapGettersOfPrivatePlot } =
  createNamespacedHelpers("gkmgPrivatePlot");

import PlotSelect from "@/views/enterprise/management/privatePlot/select/PlotSelect";
import PrivatePlotItem from "./PrivatePlotItem";

export default {
  name: "PrivatePlot",
  mixins: [ColorMixin],
  components: {
    VuePerfectScrollbar,
    PlotSelect,
    PrivatePlotItem,
  },
  data() {
    return {
      active: false,
      settings: {
        suppressScrollX: true,
        maxScrollbarLength: 60,
        wheelSpeed: 0.6,
      },
      enterpriseId: "",
    };
  },
  async created() {
    const user = await AuthService.getUser();
    this.enterpriseId = user.id;
  },
  computed: {
    ...mapStateOfLiveMap({
      activePrivatePlotSidebar: (state) => state.activePrivatePlotSidebar,
    }),
    ...mapGettersOfPrivatePlot(["getEnterprisePrivatePlots"]),
    enterprisePrivatePlots() {
      return this.getEnterprisePrivatePlots(this.enterpriseId);
    },
    scrollbarTag() {
      return this.$store.state.is_touch_device ? "div" : "VuePerfectScrollbar";
    },
  },
  methods: {
    ...mapMutationsOfLiveMap(["SET_ACTIVE_PRIVATE_PLOT_SIDEBAR"]),
    ...mapActionsOfLiveMap(["showVesselDetail"]),
    ...mapMutationsOfLiveMap(["SET_JUMP_TO_MAP"]),
    // 選択したプロットの座標にズームされる
    async jumpToPlot(plot) {
      if (
        !plot ||
        !plot.center_point ||
        plot.center_point.longitude == null ||
        plot.center_point.latitude == null
      ) {
        this.showFailureMessage();
        return;
      }
      let coordinates = {
        center: [plot.center_point.longitude, plot.center_point.latitude],
      };
      this.SET_JUMP_TO_MAP(coordinates);
    },
    // 位置情報取得に失敗したときのメッセージ
    showFailureMessage() {
      this.$vs.notify({
        title: "位置情報がありません",
        color: "warning",
        iconPack: "feather",
        icon: "icon-alert-circle",
      });
    },
  },
};
</script>

<style lang="scss">
@import "src/assets/scss/aisea/variables";

#map-controls-sidebar-private-plot {
  .vs-sidebar {
    width: 400px;
    max-width: 90vw;
    background-color: $aisea-dark-blue;
    opacity: 1;
  }
  .scroll-area--customizer {
    height: calc(100% - 10rem);
  }
  .vs-button-primary.vs-button-filled {
    background-color: $aisea-blue !important;
  }
}
</style>
